module.exports = __webpack_public_path__ + "media/cfb-national-champions.1581f75f.mp4";